(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { createContext } from 'react';
import PropTypes from 'prop-types';
export var Context = createContext({});

var Form = function Form(props) {
  var children = props.children,
      validation = props.validation,
      state = props.state,
      values = props.values,
      _props$onFieldBlur = props.onFieldBlur,
      onFieldBlur = _props$onFieldBlur === void 0 ? function (name) {
    return function (e) {
      console.warn('No blur function is provided');
    };
  } : _props$onFieldBlur;
  var formContext = {
    validation: validation,
    state: state,
    values: values,
    onFieldBlur: onFieldBlur
  };
  return React.createElement(Context.Provider, {
    value: formContext
  }, children);
};

Form.defaultProps = {
  validation: {},
  state: {}
};
Form.propTypes = {
  // eslint-disable-next-line
  validation: PropTypes.objectOf(PropTypes.shape({
    errors: PropTypes.arrayOf(PropTypes.string)
  })),
  // eslint-disable-next-line
  state: PropTypes.shape({
    validateAll: PropTypes.bool
  })
};
var _default = Form;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Context, "Context", "/home/vsts/work/1/s/src/components/forms/Form.js");
  reactHotLoader.register(Form, "Form", "/home/vsts/work/1/s/src/components/forms/Form.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/forms/Form.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();